import { generateUrlParams } from "../../utils/generateUrlParams";

const baseUrl = "SchoolProgramme";

export const getSchoolProgrammesUrl = () =>
	`${baseUrl}/GetSchoolProgrammes/get-all-school-programmes`;
export const createSchoolProgrammeUrl = () =>
	`${baseUrl}/CreateProgramme/create-school-programme`;
export const deleteSchoolProgrammeUrl = (id) =>
	`${baseUrl}/DeleteProgramme/delete-school-programme?programmeId=${id}`;
export const downloadProgrammeUploadTemplateUrl = () =>
	`${baseUrl}/DownloadProgrammeUploadTemplatet/download-programme-upload-template`;
export const getPaginatedSchoolProgrammesUrl = (filter) =>
	`${baseUrl}/GetProgrammes//get-all-school-programes?${generateUrlParams(
		filter
	)}`;
export const toggleProgrammeActivationStatusUrl = (id) =>
	`${baseUrl}/ToggleProgrammeStatus/toggle-school-programme-activation?programmeId=${id}`;
export const updateSchoolProgrammeUrl = () =>
	`${baseUrl}/UpdatesProgrammes/update-school-programme`;
export const uploadSchoolProgrammeUrl = () =>
	`${baseUrl}/UploadProgrammes/upload-school-programmes`;
